import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib/cn';

type ScoreCardProps = {
  scoreValue: string;
  onScoreChange: (v: string) => void;
  maxScore: number;
  disabled?: boolean;
  size?: 'default' | 'large';
  className?: string;
};

export function ScoreCard({
  scoreValue,
  onScoreChange,
  maxScore,
  disabled = false,
  size = 'default',
  className,
}: ScoreCardProps): ReactElement {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'rounded-dg-card border border-slate-200/80 bg-white p-4 shadow-sm dark:border-slate-700/70 dark:bg-slate-900/50',
        className
      )}
    >
      <h3 className="text-dg-card-title font-semibold text-slate-900 dark:text-white">
        {t('audit.gradeStudio.scoreTitle')}
      </h3>
      <div className="mt-3 flex items-end gap-3">
        <div className="min-w-0 flex-1">
          <label htmlFor="dg-grade-score" className="sr-only">
            {t('audit.editor.scoreLabel', { max: maxScore })}
          </label>
          <input
            id="dg-grade-score"
            type="number"
            inputMode="numeric"
            disabled={disabled}
            min={0}
            max={maxScore}
            step={1}
            value={scoreValue}
            onChange={(e) => onScoreChange(e.target.value)}
            className={cn(
              'w-full rounded-dg-control border border-slate-200/90 bg-white px-3 text-center font-semibold tabular-nums text-slate-900 outline-none focus:border-dg-accent-grade/50 focus:ring-2 focus:ring-dg-accent-grade/20 disabled:opacity-50 dark:border-slate-600 dark:bg-slate-950 dark:text-white',
              size === 'large' ? 'h-16 text-3xl' : 'h-12 text-lg'
            )}
          />
        </div>
        <div className="pb-2 text-dg-body font-medium tabular-nums text-slate-500 dark:text-slate-400">
          / {maxScore}
        </div>
      </div>
    </div>
  );
}
